import React from "react";
import { PageMeta } from "@/components/PageMeta";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CtaBand } from "@/components/CtaBand";
import { AREAS, BRAND } from "@/config/brand";
import { MapPin } from "lucide-react";

export default function Areas() {
    return (
        <div>
            <PageMeta title="Areas We Cover — YS Removals London" description="YS Removals works across Central, North, South, East and West London and surrounding boroughs." canonical={`https://${BRAND.domain}/areas`} />
            <section className="bg-[#001B3D] text-white">
                <div className="container-ys section">
                    <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Areas We Cover" }]} />
                    <h1 className="mt-3 text-4xl sm:text-5xl font-semibold tracking-tight font-heading">Areas we cover</h1>
                    <p className="mt-3 text-white/85 max-w-2xl">We work London-wide — pick a familiar borough or ask us about your postcode.</p>
                </div>
            </section>
            <section className="container-ys section grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
                {AREAS.map((a) => (
                    <div key={a} className="rounded-xl bg-white border border-[#17252D]/10 p-4 flex items-center gap-3">
                        <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-[#001B3D]/10 text-[#001B3D]"><MapPin className="h-4 w-4" /></span>
                        <div>
                            <div className="font-medium">{a}</div>
                            <div className="text-xs text-[#17252D]/70">Removals, man and van and single-item moves.</div>
                        </div>
                    </div>
                ))}
            </section>
            <CtaBand />
        </div>
    );
}
